/* globals dataLayer, angular */
(function (window, angular, undefined) {
    angular.module('formApp')
        .component('yourDetails', {
            templateUrl: 'components/your-details/templates/your-details.html',
            bindings: {
                formData: '<',
                eQuote: '<',
                eCoverNote: '<'
            },
            controller: ['dataUtils', '$filter', function (dataUtils, $filter) {
                var ctrl = this;
                ctrl.combined = sessionStorage.getItem('journeyType') === 'combined' || sessionStorage.getItem('journeyType') === 'combined2';
            }]
        });
})(window, window.angular);